function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

var SvgPntLogoPadded = function SvgPntLogoPadded(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2596 1400",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "PNT-Logo--Dark--Square-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-44",
    d: "m1466.67 912.5 75 113.487 75-113.487h166.666l-158.333 239.583 158.333 239.584H1616.67l-75-113.488-75 113.488h-166.667l158.333-239.584L1300.003 912.5h166.667Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-Copy-24",
    d: "M2300 1391.67h150v-700h-150v700Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-Copy-23",
    d: "M691.667 779.167h-150V962.5H420.833v141.667h120.834v287.5h150v-287.5h125V962.5h-125V779.167Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-43",
    d: "M911.207 225 987.5 339.475 1063.793 225h169.54l-161.062 241.667 161.062 241.666h-169.54L987.5 593.858l-76.293 114.475h-169.54l161.062-241.666L741.667 225h169.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-Copy-22",
    d: "M1733.33 708.333h150v-700h-150v700Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-Copy-21",
    d: "M545.833 708.333h150V225h-150v483.333Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-42",
    d: "M258.333 225C391.802 225 500 333.198 500 466.667c0 133.468-108.198 241.666-241.667 241.666-34.048 0-66.452-7.041-95.834-19.747l.001 373.914H16.667V466.667C16.667 333.198 124.865 225 258.333 225Zm-2.083 150c-51.777 0-93.75 41.973-93.75 93.75s41.973 93.75 93.75 93.75S350 520.527 350 468.75 308.027 375 256.25 375Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-41",
    d: "M1445.83 225c133.469 0 241.667 108.198 241.667 241.667 0 16.262-1.606 32.149-4.669 47.511l.502 6.655-313.83.005c16.591 24.891 44.919 41.662 76.33 41.662 20.706 0 39.654-6.203 55.137-16.663l173.263.001c-32.782 94.585-122.66 162.495-228.4 162.495-133.468 0-241.666-108.198-241.666-241.666 0-133.469 108.198-241.667 241.666-241.667Zm0 150c-29.255 0-55.834 14.547-72.749 37.503l149.373-.003c-17.33-22.954-44.917-37.5-76.624-37.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-40",
    d: "M1087.5 908.333c133.469 0 241.667 108.198 241.667 241.667 0 16.262-1.607 32.149-4.669 47.511l.502 6.656-313.83.004c16.591 24.891 44.918 41.662 76.33 41.662 20.705 0 39.654-6.203 55.137-16.663l173.263.002c-32.782 94.585-122.66 162.495-228.4 162.495-133.469 0-241.667-108.198-241.667-241.667S954.031 908.333 1087.5 908.333Zm0 150c-29.255 0-55.834 14.547-72.749 37.503l149.373-.003c-17.33-22.954-44.917-37.5-76.624-37.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-39",
    d: "M2000 908.333c133.469 0 241.667 108.198 241.667 241.667 0 16.262-1.607 32.149-4.669 47.511l.502 6.656-313.83.004c16.591 24.891 44.918 41.662 76.33 41.662 20.705 0 39.654-6.203 55.137-16.663l173.263.002c-32.782 94.585-122.66 162.495-228.4 162.495-133.469 0-241.667-108.198-241.667-241.667S1866.531 908.333 2000 908.333Zm0 150c-29.255 0-55.834 14.547-72.749 37.503l149.373-.003c-17.33-22.954-44.917-37.5-76.624-37.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 622.917,
    cy: 102.083,
    r: 93.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M2375 416.667v204.166h-204.167V416.667H2375ZM2579.167 212.5v204.167H2375V212.5h204.167Zm-408.334 0v204.167h-204.166V212.5h204.166ZM2375 8.333V212.5h-204.167V8.333H2375Z",
    style: {
      fill: "#46a4d9"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPntLogoPadded);
export default ForwardRef;